import React, { useState, useEffect } from 'react';
import { TextField, FormControl } from '@mui/material';
import { textFieldStyles } from "../styles/textFieldStyles";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import format from "date-fns/esm/format";
import parse from "date-fns/esm/parse";
import enGB from "date-fns/esm/locale/en-GB";

/**
 * Custom date picker component that formats dates in dd/mm/yyyy format
 * 
 * @param {Object} props - Component props
 * @param {string} props.label - Label for the date picker
 * @param {string} props.value - Date value in ISO format (YYYY-MM-DD)
 * @param {function} props.onChange - Function to call when date changes
 * @param {boolean} props.required - Whether the field is required
 * @param {Object} props.sx - Additional styles to apply
 * @param {string} props.size - Size of the text field
 * @returns {JSX.Element} - Custom date picker component
 */
const CustomDatePicker = ({ 
  label, 
  value, 
  onChange, 
  required = false, 
  sx = { width: "30%" }, 
  size = "small" 
}) => {
  // Parse the ISO date string to a Date object
  const parsed = value ? parse(value, 'yyyy-MM-dd', new Date()) : null;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={enGB}
    >
      <DatePicker
        label={label}
        value={parsed}
        onChange={(newDate) => {
          if (newDate) {
            onChange(format(newDate, 'yyyy-MM-dd'));
          } else {
            onChange('');
          }
        }}
        inputFormat="dd/MM/yyyy"
        mask="__/__/____"
        slotProps={{
          textField: {
            size: size,
            required: required,
            fullWidth: true,
            sx: {
              ...textFieldStyles(sx),
              marginLeft: '4px',
              '& .MuiOutlinedInput-root': {
                height: '32px',
                borderRadius: 0,
              },
              '& .MuiInputBase-input': {
                padding: '6.5px 14px',
                fontSize: '0.875rem',
              },
              '& .MuiInputAdornment-root': {
                height: '32px',
                maxHeight: '32px',
                marginLeft: 0,
              },
              '& .MuiInputAdornment-root button': {
                padding: '4px',
              },
              '& .MuiInputAdornment-root svg': {
                fontSize: '1.2rem',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: 0,
              }
            }
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker; 